import React from 'react'

export default function Comingsoon() {
  return (
    <div>
      <div className="first_nav_hero_about">
  {/* ======== 11.1. Coming hero section ======== */}
  <section>
    <div className="container">
      <div className="row coming-hero d-flex gap-md-0 gap-sm-4 gap-4">
        <div
          className="col-lg-6 col-md-6 d-flex align-items-center justify-content-center"
          data-aos="fade-up"
        >
          <figure className="d-flex align-items-center justify-content-lg-end justify-content-md-center justify-content-center">
            <img
              src="/assets/New/image 6.svg"
              className="moving"
              alt="img"
            />
          </figure>
        </div>
        <div
          className="col-lg-6 col-md-6 d-flex flex-column align-items-md-start align-items-ms-center align-items-center text-md-start text-sm-center text-center"
          data-aos="fade-down"
        >
          <h3>WE ARE</h3>
          <h2>COMING SOON</h2>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi
            nihil numquam natus corporis dolorem obcaecati esse, deleniti ex
            maiores libero?
          </p>
          <a className="btn-hover1" href="/">
            Back to Home
          </a>
        </div>
      </div>
    </div>
  </section>
  {/* ======== End of 11.1. Coming hero section ======== */}
  {/* ======== 11.2. Coming footer section ======== */}
  <div className="footer-coming">
    <div className="d-flex align-items-center justify-content-center gap-4">
      <a href="/#">
        {" "}
        <i className="fa-brands fa-facebook-f" />
      </a>
      <a href="/#">
        {" "}
        <i className="fa-brands fa-twitter" />
      </a>
      <a href="/#">
        {" "}
        <i className="fa-brands fa-instagram" />
      </a>
    </div>
    <p className="text-center ps-1 pe-1">
      Copyright © 2024 Finkey Pay. All Right Reserved.
    </p>
  </div>
  {/* ======== End of 11.2. Coming footer section ======== */}
</div>

    </div>
  )
}
